import React from 'react';
import PropTypes from 'prop-types';
import Stats from './Stats';
import {compose, graphql} from 'react-apollo';
import moment from 'moment';

import Loading from "components/Loading";

import {injectIntl, defineMessages} from "react-intl";

import StatsQuery from 'gql/stats.gql';

import {graphQLErrorProcesor} from "helpers/errors";
import {requireLoggedUser} from "helpers/login";
import {withOperator} from 'helpers/operator';
import {withOperatorAds} from 'helpers/operatorAds';

const messages = defineMessages({
    all_ads: {
        id: "stats.all_ads",
        defaultMessage: "All ads"
    }
});

class StatsProvider extends React.Component {
    static propTypes = {
        statsQuery: PropTypes.object.isRequired,
        operator: PropTypes.object.isRequired,
        onLogout: PropTypes.func.isRequired,
        onOnlineChange: PropTypes.func.isRequired,
        intl: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);

        this.changeDateFrom = this.changeDateFrom.bind(this);
        this.changeDateTo = this.changeDateTo.bind(this);
        this.changeOperatorAd = this.changeOperatorAd.bind(this);
        this.changeOperatorCustomer = this.changeOperatorCustomer.bind(this);
        this.refetchData = this.refetchData.bind(this);
    }

    componentWillMount() {
        this.setState({
            dateTo: moment().endOf('day'),
            dateFrom: moment().endOf('day').subtract(1, "months"),
            adId: '',
            customerId: '',
            operatorId: this.props.user.id
        })
    }

    changeDateFrom(date) {
        date.startOf('day');
        this.setState({
            dateFrom: date,
        }, this.refetchData);
    }

    changeDateTo(date) {
        this.setState({
            dateTo: date,
        }, this.refetchData);
    }

    changeOperatorAd(adId) {
        this.setState({
            adId
        }, this.refetchData);
    }

    changeOperatorCustomer(customerId) {
        this.setState({
            customerId
        }, this.refetchData);
    }

    changeOperatorId(operatorId) {
        this.setState({
            operatorId
        }, this.refetchData);
    }

    refetchData() {
        this.props.statsQuery.refetch({
            id: this.state.operatorId,
            dateFrom: this.state.dateFrom.unix(),
            dateTo: this.state.dateTo.unix(),
            adId: this.state.adId
        });
    }

    render() {
        const {operator, onOnlineChange, statsQuery, intl, operatorAds, onLogout} = this.props;
        const {dateFrom, dateTo, adId} = this.state;

        const {loading: loadingStats, stats, loadMoreContacts} = statsQuery;

        let total = 0, history = [], historyLength = 0, ads = [];
        if (!loadingStats) {
            total = parseFloat(stats.total);
            historyLength = parseInt(stats.numContacts, 10);
            history = stats.contacts.map(contact => ({
                date: moment.unix(contact.timeCreated),
                revenue: contact.revenue !== null ? parseFloat(contact.revenue) : null,
                type: contact.type,
                direction_received: contact.directionReceived,
                phone: contact.phone,
                timeStarted: contact.voice && contact.voice.timeStarted && moment.unix(contact.voice.timeStarted),
                timeFinished: contact.voice && contact.voice.timeFinished && moment.unix(contact.voice.timeFinished),
            }));
        } else {
            return <Loading/>
        }

        if (operatorAds) {
            ads = operatorAds.map(ad => ({
                name: ad.heading,
                value: ad.id.toString()
            }));

            // The first element empty
            ads.unshift({
                name: intl.formatMessage(messages.all_ads),
                value: ''
            })
        }

        return (
            <Stats operator={operator} onLogout={onLogout} onOnlineChange={onOnlineChange}
                   onLoadMoreContacts={loadMoreContacts} dateFrom={dateFrom} dateTo={dateTo} adId={adId}
                   onChangeDateFrom={this.changeDateFrom} onChangeDateTo={this.changeDateTo}
                   onChangeOperatorAd={this.changeOperatorAd}
                   onOperatorChange={this.changeOperatorId} loading={loadingStats} total={total} history={history}
                   historyLength={historyLength} ads={ads}
            />
        )
    }
}

export default (compose(
    injectIntl,
    requireLoggedUser,
    withOperator,
    withOperatorAds,
    graphql(StatsQuery, {
        name: 'statsQuery',
        options: props => ({
            variables: {
                operator: props.user.id,
                dateTo: moment().endOf('day').unix(),
                dateFrom: moment().startOf('day').subtract(1, "months").unix(),
                limit: 10,
                offset: 0
            },
            fetchPolicy: 'network-only'
        }),
        props({statsQuery: {stats, fetchMore, ...rest}}) {
            return {
                statsQuery: {
                    stats,
                    ...rest,
                    loadMoreContacts() {
                        return fetchMore({
                            variables: {
                                offset: stats.contacts.length,
                            },
                            updateQuery: (previousResult, {fetchMoreResult}) => {
                                if (!fetchMoreResult) {
                                    return previousResult;
                                }
                                const stats = Object.assign({}, previousResult.stats, {contacts: [...previousResult.stats.contacts, ...fetchMoreResult.stats.contacts]});
                                return Object.assign({}, previousResult, {stats});
                            }
                        })
                    }
                }
            }
        }
    }),
    graphQLErrorProcesor(['statsQuery']),
)(StatsProvider));


// WEBPACK FOOTER //
// ./src/containers/Stats/index.jsx